
import Purchases from "../page/Purchases/Purchases"
import Sales from "../page/Sale/Sales"
import Transactions from "../page/Transactions/Transactions"
import Stocks from "../page/Stock/Stocks"
import Clients from "../page/Clients/Clients"
import StockIcon from "../images/StockIcon"
import PurchasesIcon from "../images/PurchasesIcon"
import ClientsIcon from "../images/ClientsIcon"
// import TransactionsIcon from "./images/TransactionsIcon"
// import SidebarIcon from "./images/SidebarIcon"
import SalesIcon from "../images/SalesIcon"
import PurchasesIconActive from "../images/PurchasesIconActive"
import SalesIconActive from "../images/SalesIconActive"
import StockIconActive from "../images/StockIconActive"
import ClientsIconActive from "../images/ClientsIconActive"
import PagePurchase from "../page/Purchases/PagePurchases"
import PageSales from "../page/Sale/PageSales"
import PageCreateClients from "../page/Clients/PageCreateClients"
const HomeSidebar = [
    // /dashboard is served by inventory-web's registry now; keeping an entry
    // here would win the route and pin the old accounting overview.
    {
        index: 2,
        name: "Purchases",
        show: true,
        showRoute: true,
        path: "/purchases",
        component: Purchases,
        image: PurchasesIcon,
        imageActive: PurchasesIconActive
    },
    {
        index: 3,
        name: "Purchases",
        show: false,
        showRoute: true,
        path: "/purchases/new",
        component: PagePurchase,
        image: SalesIcon,
        imageActive: SalesIconActive
    },
    {
        index: 4,
        name: "Purchases",
        show: false,
        showRoute: true,
        path: "/purchases/:id",
        component: PagePurchase,
        image: SalesIcon,
        imageActive: SalesIconActive
    },
    {
        index: 5,
        name: "Sales",
        show: true,
        showRoute: true,
        path: "/sales",
        component: Sales,
        image: SalesIcon,
        imageActive: SalesIconActive
    },
    {
        index: 6,
        name: "Sales",
        show: false,
        showRoute: true,
        path: "/sales/new",
        component: PageSales,
        image: SalesIcon,
        imageActive: SalesIconActive
    },
    {
        index: 7,
        name: "Sales",
        show: false,
        showRoute: true,
        path: "/sales/:id",
        component: PageSales,
        image: SalesIcon,
        imageActive: SalesIconActive
    },
    {
        index: 8,
        name: "Clients",
        show: false,
        showRoute: true,
        path: "/clients/new",
        component: PageCreateClients,
        image: SalesIcon,
        imageActive: SalesIconActive
    },
    {
        index: 9,
        name: "Inventory",
        show: true,
        showRoute: true,
        path: "/inventory",
        component: Stocks,
        image: StockIcon,
        imageActive: StockIconActive
    },
    {
        index: 10,
        name: "Clients",
        show: true,
        showRoute: true,
        path: "/clients",
        component: Clients,
        image: ClientsIcon,
        imageActive: ClientsIconActive
    },
    {
        index: 11,
        name: "Clients",
        show: false,
        showRoute: true,
        path: "/clients/:id",
        component: PageCreateClients,
        image: SalesIcon,
        imageActive: SalesIconActive
    },
]
export default HomeSidebar